import UserInfo from "../../components/user/UserInfo.vue";
export default {
  components: {
    UserInfo: UserInfo
  }
};